import { Language, PlanSlugs, User, UserResponse } from "@/@types";
import { ConnectAccountDue, UserAvatar } from "@/constants";
import { useProfileImprovement } from "@/hooks";
import { phoneMask } from "@/utils";
import LanguagesObj from "@/utils/LanguagesObj";
import moment from "moment";
import pkg from "../../package.json";

export class UserMapper {
  static toDomain(data: UserResponse): User {
    let connect_account: any = data.connect_account;
    let connect_account_currently_due: string[] = [];
    if (connect_account) {
      connect_account.legal_name =
        connect_account.business_type === "individual"
          ? `${connect_account.individual_first_name} ${connect_account.individual_last_name}`
          : connect_account.company_name;
      connect_account.business_type_name =
        connect_account.business_type === "individual"
          ? "Pessoa Física"
          : "Pessoa Jurídica";

      if (connect_account.currently_due) {
        connect_account.currently_due.split("|").map((item: string) => {
          if (item === "external_account") return;
          connect_account_currently_due.push(ConnectAccountDue[item]);
        });
      }
    }

    const nickname = data.nickname || data.name.split(" ")[0];

    const userAvatar =
      UserAvatar[String(data.gender === "female" ? 1 : 2)] || UserAvatar["1"];
    const userImage = `${process.env.VUE_APP_IMG_BASE_URL}${data.profile_image}`;
    const profile_image = data.profile_image ? userImage : userAvatar;

    const formatted_phone = phoneMask.formatWithCountry(
      data.phone,
      data.country_code,
    );

    const formatted_ratings_as_psi_count = `${
      data?.ratings_as_psi_count || 0
    } ${
      data?.ratings_as_psi_count && data?.ratings_as_psi_count == 1
        ? "depoimento"
        : "depoimentos"
    }`;

    const formatted_valid_appointments_as_psi_count = `${
      data?.valid_appointments_as_psi_count || 0
    } ${
      data?.valid_appointments_as_psi_count &&
      data?.valid_appointments_as_psi_count == 1
        ? "sessão"
        : "sessões"
    }`;

    const formatted_languages = data.languages
      ? data.languages.map(
          (language: Language) =>
            `${language?.detail?.name} ${
              LanguagesObj[language?.detail?.code]?.flag
            }`,
        )
      : [];

    const formatted_intro_video_link = `https://youtube.com/watch?v=${data?.intro_video_link}`;

    const profile_improvement_values = useProfileImprovement(
      data.profile_improvement,
    );

    const formatted_years_exp = `${data?.years_exp} ano(s) de experiência`;

    const formatted_latest_ratings = data.latest_ratings
      ? data.latest_ratings.map((rating: any) => ({
          ...rating,
          formatted_profile_image: rating.user
            ? UserAvatar[rating.user.profile_image]
            : null,
          formatted_date: moment(rating.created_at).format(
            "DD[ de ]MMMM[ de ]YYYY",
          ),
        }))
      : [];

    const document_image = data.document_image
      ? process.env.VUE_APP_IMG_BASE_URL + data.document_image
      : "";

    const document_in_hand = data.document_in_hand
      ? process.env.VUE_APP_IMG_BASE_URL + data.document_in_hand
      : "";

    let is_subscriber = false;
    let is_plus = false;
    let can_login = false;

    if (data.subscription) {
      const status = data.subscription?.status;
      const trialEnd = data.subscription?.trial_end;
      const cancelAt = data.subscription?.cancel_at;
      const slug = data.subscription?.plan.slug;

      const isTrialingCanceledStillValid =
        status === "canceled" && trialEnd && moment(trialEnd).isAfter(moment());

      const isScheduledToCancel =
        status !== "incomplete" &&
        cancelAt &&
        moment(cancelAt).isAfter(moment());

      is_subscriber = !!(
        status === "past_due" ||
        status === "active" ||
        status === "trialing" ||
        isTrialingCanceledStillValid ||
        isScheduledToCancel
      );

      is_plus = !!(
        is_subscriber &&
        (slug === PlanSlugs.plus || slug === PlanSlugs.free)
      );

      can_login = !!(data.approved && data.stripe_id && is_subscriber);
    }

    const on_holding = !data.approved || !data.stripe_id || !is_subscriber;

    return {
      version: pkg.version,
      ...data,
      nickname,
      connect_account,
      formatted_phone,
      formatted_ratings_as_psi_count,
      formatted_valid_appointments_as_psi_count,
      formatted_languages,
      formatted_intro_video_link,
      formatted_years_exp,
      profile_improvement_values,
      formatted_latest_ratings,
      document_image,
      document_in_hand,
      connect_account_currently_due,
      profile_image,
      can_login,
      on_holding,
      is_subscriber,
      is_plus,
    };
  }
}
